<template>
    <div class="my-auto mx-auto xl:ml-20 w-full sm:w-3/4 lg:w-2/4 xl:w-auto">

        <img alt="mitsubishi login Logo" class="-intro-x w-1/2 xl:hidden mx-auto mb-8" src="/dist/images/logoh.png">

        <div class="bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none ">
            <!--Restablecer Contraseña-->
            <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left xl:text-white">Restablecer Contraseña</h2>
            <div class="-intro-x text-lg xl:text-white">Introduce tu nueva contraseña</div>
            <div class="intro-x mt-8">
                <form @keyup.enter="reset" class="bg-white p-4">
                    <input v-model="form.email" type="text" class="login__input input input--lg border border-gray-300 block" :class="{ 'border-theme-6': $getErrorClasses(errorMessages, 'email') }" placeholder="Email" disabled>
                    <div v-if="$isset(errorMessages)" class="w-5/6 text-theme-6 mt-2" v-for="message in errorMessages.email">{{ message }}</div>
                    <input v-model="form.password" type="password" class="login__input input input--lg border border-gray-300 block mt-4" :class="{ 'border-theme-6': $getErrorClasses(errorMessages, 'password') }" placeholder="Escribe tu nueva contraseña">
                    <input v-model="form.password_confirmation" type="password" class="login__input input input--lg border border-gray-300 block mt-4" placeholder="Confirmar nueva contraseña">
                    <div v-if="$isset(errorMessages)" class="w-5/6 text-theme-6 mt-2" v-for="message in errorMessages.password">{{ message }}</div>
                </form>
            </div>
            <div class="-intro-x mt-5 xl:mt-8 flex justify-center xl:justify-start">
                <button @click="reset" class="button button--lg w-full text-white bg-theme-1 xl:mr-3">
                    <template v-if="!requestState">Restablecer Contraseña</template>
                    <animated-icon v-else icon="oval" color="white" class="w-5 h-5 block mx-auto"></animated-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            mail: String,
            token: String
        },
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    password_confirmation: ''
                },
                requestState: false,
                errorMessages: []
            }
        },
        methods: {
            async reset() {
                this.requestState = true
                await this.$delay(1000)

                this.$req.auth.reset(this.form).then(async res => {
                    window.location.href = '/inicio'
                }).catch(err => {
                    this.requestState = false;
                    this.form.password = '';
                    this.form.password_confirmation = '';
                    this.errorMessages = err.response.data.errors
                })
            },
        },
        mounted: function () {
            this.form.email = this.mail;
            this.form.token = this.token;
        }
    }
</script>
